module.exports = __webpack_public_path__ + "img/logo-educlimber.6a01af90.png";